export type IRouteState = {
  currentPath: string;
};

export const state: IRouteState = {
  currentPath: "/home"
};
